import { typeActions } from 'state/util'

const { actions, types } = typeActions('admin', {
  fetchAll: meta => ({
    meta,
  }),
  fetchWalletProductsAll: () => ({ }),
  fetchProducts: () => ({ }),
  fetchUnits: () => ({ }),
  fetchDefaulters: () => ({ }),
  createDefaulter: data => ({ payload: data }),
  patchDefaulter: (data, command) => ({ payload: data, command }),
  createWalletProduct: data => ({ payload: data }),
  postCoupon: data => ({ payload: data }),
  deleteCoupon: id => ({ payload: id }),
  updateWalletProduct: (id, data) => ({ payload: id, meta: data }),
  fetchOne: (payload, meta) => ({
    payload,
    meta,
  }),
  setData: (type, payload) => ({
    payload: { [type]: payload }
  }),
  setLoading: value => ({ meta: { loading: value } }),
  editDefaulters: value => ({ meta: { unit: value } }),
  openModal: () => ({ }),
  setLoadingUpdate: value => ({ meta: { loadingUpdate: value } }),
  sendData: (data, meta = null) => ({ payload: data, meta }),
  setWalletProducts: (data, meta = null) => ({ payload: data, meta }),
  setUnits: (data, meta = null) => ({ payload: data, meta }),
  setDefaulters: (data, meta = null) => ({ payload: data, meta }),
  setProducts: (data, meta = null) => ({ payload: data, meta }),
  sendPatchData: (data, meta = null) => ({ payload: data, meta }),
  generateLabels: data => ({ meta: { id: data } }),
  changeStatusOrder: meta => ({ meta }),
  sendOrderNf: (data, meta) => ({ payload: data, meta }),
  sendEnableBasicKitRequired: (email, enableBasicKitRequired) => ({ payload: { email, enableBasicKitRequired } }),
  updatePurchaseLimit: (
    email, purchaseLimit, purchaseLimitType = 'monthly', purchaseLimitPeriodStart = null, purchaseLimitPeriodEnd = null,
  ) => ({
    payload: {
      email, purchaseLimit, purchaseLimitType, purchaseLimitPeriodStart, purchaseLimitPeriodEnd,
    },
  }),
  setUnit: data => ({ payload: data }),
  updateAllowOrderWhileProcessing: (email, allowOrderWhileProcessing) => ({ payload: { email, allowOrderWhileProcessing } }),
  setSavingAllowOrder: email => ({ meta: { email } }),
  fetchOrdersProcessing: () => ({ }),
  setOrdersProcessing: (data, loading = false) => ({ payload: data, meta: { loading } }),
  setSavingPurchaseLimit: email => ({ meta: { email } }),
  getKitIdSaga: kitId => (kitId)
})

export {
  actions,
  types,
}
